<template>
  <Record class="RecordPage">
    <Row>
      <Column :sm="4">
        <Set
          icon="link"
          :label="$t('link')">
          <a :href="page.url">
            {{ page.url }}
          </a>
        </Set>
      </Column>
      <Column :sm="4">
        <Field
          :disabled="isPatching"
          :label="$t('status')"
          :options="pageStatuses"
          type="select"
          :value="page.status"
          @update:value="setStatus" />
      </Column>
      <Column :sm="4">
        <Set icon="exclamation">
          <Btn
            v-if="hasError"
            class="danger"
            @click="doShowError = true">
            {{ $t('viewError') }}
          </Btn>
        </Set>
      </Column>
    </Row>
    <div slot="meta">
      {{ page.updatedAt | relativeTime }}
    </div>
    <Modal
      v-if="doShowError"
      @close="doShowError = false">
      <pre>{{ JSON.stringify(page.error, null, '\t') }}</pre>
    </Modal>
  </Record>
</template>

<script>
import { actions, getters } from '@utils'
import Record from '@components/Record'

export default {
  components: {
    Record,
  },
  props: {
    page: Object,
  },
  data() {
    return {
      doShowError: false,
      isPatching: false,
    }
  },
  computed: {
    hasError() {
      return !!Object.keys(this.page.error).length
    },
    ...getters('pageStatuses'),
  },
  methods: {
    setStatus(status) {
      return this.$wrap(() => this
        .PATCH_PAGE({
          id: this.page.id,
          status,
        }), 'isPatching')
    },
    ...actions('PATCH_PAGE'),
  },
}
</script>

<style lang="scss">
.RecordPage {
}
</style>

<i18n>
{
  "en": {
    "link": "Link",
    "status": "Status",
    "viewError": "View error"
  }
}
</i18n>
